<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar bgTable"
        elevation="0"
      >
        <v-text-field
          class="mr-8"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />

        <avs-createButton
          :spantext="$t('actions.create', { entity: $t('commons.action').toLowerCase() })"
          menu
          :name="$t('actions.new', { entity: $t('commons.action').toLowerCase() })"
          @click="handleOpenEditDialogByComponent()"
        >
        </avs-createButton>
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10 bgTable"
        dense
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :items="items"
        :items-per-page="-1"
        :search="search"
        item-key="id"
        @dblclick:row="
          ($event, { item }) => {
            if (allow.duplicate(item)) {
              handleOpenEditDialog(item)
            }
          }
        "
      >
        <template #item.created_at="{ item }">
          {{ toDatetime(item.created_at) }}
        </template>
        <template v-slot:item.status="{ item }">
          <avs-chip :label="false">
            {{ item.status }}
          </avs-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <avs-editButton
              @click.stop="handleOpenEditDialog(item)"
              :spantext="$t('actions.edit', { entity: $t('commons.fieldtype').toLowerCase() })"
            />

            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="$t('actions.delete', { entity: $t('commons.fieldtype').toLowerCase() })"
            />
          </div>
        </template>
      </v-data-table>

      <v-dialog
        v-model="editDialogIsOpen"
        width="40vw"
      >
        <component
          v-model="selectedItem"
          :hasUniqueName="hasUniqueName"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Action"
      />
    </template>
  </avs-card>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
import { ActionService } from "@/services"
import { mkUnique } from "@/utils/validator"

import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue"
import ActionEditor from "@/components/ri3/documents/privileges/ActionEditor.vue"

export default {
  name: "AdminActions",
  components: { DeleteDialog, ActionEditor },
  created() {
    this.fetchFieldTypes()
  },
  computed: {
    hasUniqueName: {
      get() {
        const names = this.items.filter(e => e.name !== this.selectedItem?.name).map(e => e.name)
        return mkUnique(names, "name")
      }
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          // class: "min-width-150",
          sortable: true
        },
        {
          text: "Code",
          value: "permission_code",
          align: "center",
          sortable: true,
          filterable: false
        },
        {
          text: "Menu",
          value: "menu_name",
          align: "center",
          sortable: true,
          filterable: false
        },
        {
          text: "Creation date",
          value: "created_at",
          // class: "min-width-150",
          sortable: true,
          filterable: false
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          // width: 150,
          sortable: false,
          filterable: false
        }
      ],
      isEditable: true,
      items: [],
      search: "",

      // basecomponents: Object.values(COMPONENT_ENUM),
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined
    }
  },
  methods: {
    toDatetime,
    fetchFieldTypes() {
      ActionService.getAll().then(response => {
        this.items = response
      })
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialogIsOpen = true
    },
    handleOpenEditDialog(item) {
      this.selectedItem = item
      this.handleOpenEditDialogByComponent()
    },
    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true
      this.editDialogContent = "ActionEditor"
    },
    handleCancel() {
      this.selectedItem = undefined
      this.deleteDialogIsOpen = false
      this.editDialogIsOpen = false
      this.editDialogContent = null
    },
    handleError(message) {
      this.send(message || this.$t("messages.error.failed_admin", { role: "INSPECTOR" }), "error")
    },
    handleSuccess() {
      this.handleCancel()
      this.$nextTick(() => {
        this.fetchFieldTypes()
        this.send(this.$t("messages.success.operation"), "success")
      })
    },
    handleDelete() {
      ActionService.delete(this.selectedItem.id)
        .then(() => {
          this.handleSuccess()
        })
        .catch(error => {
          const message = error?.response.data?.state
          this.handleError(message)
        })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
